import { useContext } from 'react';
import type { LangCodeOrLocale } from './i18nProvider';
import { I18nContext } from './i18nProvider';

interface UseLanguageReturnValue {
    langCodeOrLocale: LangCodeOrLocale | undefined;
}

/**
 * useLanguage: hook to quickly access the current languageCode or locale
 */
const useLanguage = (): UseLanguageReturnValue => {
    const { langCodeOrLocale } = useContext(I18nContext);

    return { langCodeOrLocale };
};

export default useLanguage;
